<script>
import { Line } from 'vue-chartjs'
// eslint-disable-next-line
import chartjsPluginAnnotation from 'chartjs-plugin-annotation'
export default {
  name: 'ChartJSLine',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.chartOptions)
  }
}
</script>
